import { Injectable, inject, computed } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import {
  EstablishmentOpenedStatus,
  getEstablishmentTimezone,
  TemporaryClosure,
  WorkingDays,
} from '@pedix-workspace/utils';
import { Observable } from 'rxjs';
import { filter, shareReplay, switchMap } from 'rxjs/operators';
import { WorkingHoursService } from '@pedix-workspace/pedixapp-core-services';
import { AppRequestContextService } from '../../app-request-context.service';

@Injectable({ providedIn: 'root' })
export class EstablishmentWorkingHoursService {
  openedStatus$: Observable<EstablishmentOpenedStatus>;

  readonly establishment = computed(() => this.appRequestContextService.establishment());

  private workingHoursService = inject(WorkingHoursService);
  private appRequestContextService = inject(AppRequestContextService);

  constructor() {
    this.openedStatus$ = toObservable(this.establishment).pipe(
      filter(establishment => !!establishment),
      switchMap(establishment =>
        this.isEstablishmentOpened$(establishment.workingDays, establishment.temporaryClosure, {
          timezone: getEstablishmentTimezone(establishment),
          isInventoryBlocked: establishment.activeInventoryCount?.blockOrders ?? false,
        }),
      ),
      shareReplay({
        refCount: false,
        bufferSize: 1,
      }),
      takeUntilDestroyed(),
    );
  }

  isEstablishmentOpened$(
    workingDays: WorkingDays | undefined,
    temporaryClosure: TemporaryClosure | undefined,
    options: { timezone?: string; isInventoryBlocked?: boolean },
  ): Observable<EstablishmentOpenedStatus> {
    return this.workingHoursService.isEstablishmentOpened$(workingDays, temporaryClosure, options);
  }
}
